export const STATUS_ACTIVE = 'ACTIVE'
export const STATUS_PASSED = 'PASSED'
export const STATUS_CANCELLED = 'CANCEL'
export const STATUS_WAITING_LIST = 'WAITING_LIST'
export const STATUS_CONFIRMED = 'CONFIRMED'

/* --- */

export const FETCH_LOCATION_DETAILS = 'GRS_FETCH_LOCATION_DETAILS'
export const RECEIVED_LOCATION_DETAILS = 'GRS_RECEIVED_LOCATION_DETAILS'

export const FETCH_RATES = 'GRS_FETCH_RATES'
export const RECEIVED_LOCATION_RATES = 'GRS_RECEIVED_LOCATION_RATES'
export const FAILED_TO_FETCH_RATES = 'GRS_FAILED_TO_FETCH_RATES'

export const FETCH_RATE_DETAILS = 'GRS_FETCH_RATE_DETAILS'
export const RECEIVED_RATE_DETAILS = 'GRS_RECEIVED_RATE_DETAILS'

export const CREATE_RESERVATION = 'GRS_CREATE_RESERVATION'
export const RECEIVED_RESERVATION_CONFIRMATION = 'GRS_RECEIVED_RESERVATION_CONFIRMATION'

export const SAVE_BOOKING_PASS = 'GRS_SAVE_BOOKING_PASS'

export const GET_RESERVATIONS = 'GET_RESERVATIONS'
export const RECEIVED_RESERVATIONS = 'RECEIVED_RESERVATIONS'

export const GET_WAITING_LIST_RECORDS = 'GET_WAITING_LIST_RECORDS'
export const RECEIVED_WAITING_LIST_RECORDS = 'RECEIVED_WAITING_LIST_RECORDS'

export const SET_AUTO_RENEW = 'SET_AUTO_RENEW'
export const UPDATED_AUTO_RENEW = 'UPDATED_AUTO_RENEW'

export const GET_RESERVATION_CANCEL_AMEND_POLICY = 'GRS_GET_RESERVATION_CANCEL_AMEND_POLICY'
export const RESERVATION_CANCEL_AMEND_POLICY_RESPONSE = 'GRS_RESERVATION_CANCEL_AMEND_POLICY_RESPONSE'
export const CANCEL_RESERVATION = 'GRS_CANCEL_RESERVATION'
export const CANCEL_RESERVATION_RESPONSE = 'GRS_CANCEL_RESERVATION_RESPONSE'

export const CHANGE_VEHICLE = 'GRS_CHANGE_VEHICLE'
export const GET_RESERVATION_RECEIPT = 'GET_RESERVATION_RECEIPT'
export const CHANGE_VEHICLE_RESPONSE = 'GRS_CHANGE_VEHICLE_RESPONSE'

export const VALIDATE_WAITING_LIST_KEY = 'VALIDATE_WAITING_LIST_KEY'
export const VALIDATED_WAITING_LIST_KEY = 'VALIDATED_WAITING_LIST_KEY'
export const FAILED_TO_VALIDATE_WAITING_LIST_KEY = 'FAILED_TO_VALIDATE_WAITING_LIST_KEY'

export const ADD_TO_WAITING_LIST = 'GRS_ADD_TO_WAITING_LIST'
export const ADDED_TO_WAITING_LIST = 'GRS_ADDED_TO_WAITING_LIST'

export const CANCEL_WAITING_LIST = 'GRS_CANCEL_WAITING_LIST'
export const CANCELED_WAITING_LIST = 'GRS_CANCELED_WAITING_LIST'

export const GET_SEASON_TICKETS = 'GRS_GET_SEASON_TICKETS'
export const RECEIVED_SEASON_TICKETS_RATES = 'GRS_RECEIVED_SEASON_TICKETS'
export const RECEIVED_SEASON_TICKETS = 'GRS_RECEIVED_SEASON_TICKETS'
export const FAILED_TO_FETCH_SEASON_TICKET_RATES = 'GRS_FAILED_TO_FETCH_SEASON_TICKET_RATES'

export const CUSTOMER_TYPE_FLOW_HOURLY = 'RAD'
export const CUSTOMER_TYPE_FLOW_MONTHLY = 'MNY'
